import * as actionTypes from '../actions/actionTypes';

export default function (state = null, action) {
  switch (action.type) {
    case actionTypes.FETCH_APPLICATION_SUCCESS:
      return action.application;
    case actionTypes.SUBMIT_ENTITY_APPLICATION_SUCCESS:
      return action.application;
    // The hand-off PUT returns the full updated application, and the thunk rejects any 2xx
    // body without an `id`, so this is a replace like the cases above rather than a merge.
    // Without it the applicant is routed to the PDF despite a hand-off already committed
    // server-side — the store would still hold the pre-hand-off record at render time.
    case actionTypes.FORMSTACK_HANDOFF_SUCCESS:
      return action.application;
    default:
      return state;
  }
}
